import React from 'react';
import {
  FiSearch as SearchIcon,
  FiX as XIcon,
  FiMenu as MenuIcon,
  FiMail as MailIcon,
  FiPhone as PhoneIcon,
  FiHelpCircle as HelpCircleIcon,
  FiClock as ClockIcon,
  FiTag as TagIcon,
  FiChevronRight as ChevronRightIcon,
  FiThumbsUp as ThumbsUpIcon,
  FiThumbsDown as ThumbsDownIcon,
  FiPrinter as PrinterIcon,
  FiShare2 as Share2Icon,
  FiUsers as UsersIcon,
  FiCalendar as CalendarIcon,
  FiDollarSign as DollarSignIcon,
  FiPackage as PackageIcon,
  FiTool as ToolIcon,
  FiFileText as FileTextIcon,
  FiSettings as SettingsIcon,
  FiGrid as GridIcon,
  FiShoppingCart as ShoppingCartIcon,
  FiClipboard as ClipboardIcon,
  FiTrendingUp as TrendingUpIcon,
  FiMessageCircle as MessageCircleIcon,
  FiCheckCircle as CheckCircleIcon,
  FiArrowRight as ArrowRightIcon,
} from 'react-icons/fi';

// Re-export with proper typing
export const FiSearch = SearchIcon as any;
export const FiX = XIcon as any;
export const FiMenu = MenuIcon as any;
export const FiMail = MailIcon as any;
export const FiPhone = PhoneIcon as any;
export const FiHelpCircle = HelpCircleIcon as any;
export const FiClock = ClockIcon as any;
export const FiTag = TagIcon as any;
export const FiChevronRight = ChevronRightIcon as any;
export const FiThumbsUp = ThumbsUpIcon as any;
export const FiThumbsDown = ThumbsDownIcon as any;
export const FiPrinter = PrinterIcon as any;
export const FiShare2 = Share2Icon as any;
export const FiUsers = UsersIcon as any;
export const FiCalendar = CalendarIcon as any;
export const FiDollarSign = DollarSignIcon as any;
export const FiPackage = PackageIcon as any;
export const FiTool = ToolIcon as any;
export const FiFileText = FileTextIcon as any;
export const FiSettings = SettingsIcon as any;
export const FiGrid = GridIcon as any;
export const FiShoppingCart = ShoppingCartIcon as any;
export const FiClipboard = ClipboardIcon as any;
export const FiTrendingUp = TrendingUpIcon as any;
export const FiMessageCircle = MessageCircleIcon as any;
export const FiCheckCircle = CheckCircleIcon as any;
export const FiArrowRight = ArrowRightIcon as any;